import React, { Fragment, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Avatar,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Divider,
  IconButton,
  Button,
  Grid,
  Box,
  Dialog,
} from "@mui/material";
import moment from "moment";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import RichTextEditor from "react-rte";
import Editor from "../../utils/common/Editor";
import EmailGenerate from "./EmailGenerate";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import MovieIcon from "@mui/icons-material/Movie";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import EmailReplyEditorAI from "./EmailReplyEditorAI";
import { useLocation, useParams } from "react-router-dom";
import { UserLoginInfo } from "../../types/context";
import { UserContext } from "../../context/userContext";
import { appLogger, Http } from "../../utils";
import _ from "lodash";
import { withSnackbar } from "../../utils/common/SnackbarHoc";
import { apiChatUrl } from "../../utils/config";
import {
  getpageTypeEmail,
  getpageTypeForEmail,
} from "../../utils/common/common";
import MediaAttachments from "./MediaAttachments";
import Comments from "../feedback/comments";
import NameAndEmail from "../../utils/common/NameAndEmail";
import DateTime from "../../utils/common/DateTime";

interface IEmailAttachmentsProps {
  mail: any;
  setPreview: any;
  setLoader: any;
}
const EmailAttachments = ({
  mail,
  setPreview,
  setLoader,
}: IEmailAttachmentsProps) => {
  if (!mail?.attachmentInfo?.length) return null;

  const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
  const videoExtensions = ["mp4", "mov", "avi", "mkv", "webm"];

  const attachments = mail.attachmentInfo.filter(
    (a: string) => !mail.body.includes(decodeURIComponent(a.split("/")[7]))
  );

  const getFileType = (url: string) => {
    const index = url.lastIndexOf(".");
    const extension = index === -1 ? "" : url.slice(index + 1).toLowerCase();
    const path = url.split("/");
    const fileName = path[path.length - 1];

    if (imageExtensions.includes(extension))
      return { fileType: "IMAGE", fileName, extension };

    if (videoExtensions.includes(extension))
      return { fileType: "VIDEO", fileName, extension };

    return { fileType: "OTHERS", fileName, extension };
  };

  const handlePreview = (url: string, fileType: string, fileName: string) => {
    setPreview({ open: true, url, fileType, fileName });
  };

  const handleDownload = async (
    url: string,
    fileType: string,
    fileName: string
  ) => {
    try {
      setLoader(true);
      let objURL = url;
      if (fileType === "OTHERS") {
        const response = await fetch(url);
        const blob = await response.blob();
        objURL = window.URL.createObjectURL(blob);
      }
      const link = document.createElement("a");
      link.href = objURL;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
    } finally {
      setLoader(false);
    }
  };

  return (
    <List className="email-attachment-container">
      <ListItem className="email-attachment-count">
        {attachments.length} Attachments
      </ListItem>
      {attachments.map((a: string) => {
        const { fileType, fileName, extension } = getFileType(a);
        return (
          <ListItem key={a} className="email-attachment-item">
            {fileType === "IMAGE" && <img src={a} />}
            {fileType === "VIDEO" && (
              <Box className="box">
                <Box className="icon">
                  <MovieIcon fontSize="large" />
                  <span>{extension}</span>
                </Box>
                <Box className="attachment-file-name">{fileName}</Box>
              </Box>
            )}
            {fileType === "OTHERS" && (
              <Box className="box">
                <Box className="icon">
                  <DescriptionOutlinedIcon fontSize="large" />
                  <span>{extension}</span>
                </Box>
                <Box className="attachment-file-name">{fileName}</Box>
              </Box>
            )}
            <Box className="preview-and-download">
              {["IMAGE", "VIDEO"].includes(fileType) && (
                <VisibilityIcon
                  fontSize="medium"
                  onClick={() => handlePreview(a, fileType, fileName)}
                />
              )}
              <DownloadIcon
                fontSize="medium"
                onClick={() => handleDownload(a, fileType, fileName)}
              />
            </Box>
          </ListItem>
        );
      })}
    </List>
  );
};

const EmailReply = (props: any) => {
  const { feedbackDetails, updateSubject, updateStatus, pagetype, subjectVal } =
    props;
  const { userInfo } = useContext(UserContext) as UserLoginInfo;
  const [expanded, setExpanded] = useState(false);
  const [showReplySection, setshowReplySection] = useState(false);
  const [loader, setLoader] = useState(false);
  const [mails, setMails] = useState<any>([]);
  const { type, ticketId } = useParams();
  const [EmailSaluation, setEmailSaluation] = useState("");
  const [EmailSignature, setEmailSignature] = useState("");
  const [preview, setPreview] = useState({
    open: false,
    url: "",
    fileType: "",
    fileName: "",
  });
  const navigate = useNavigate();

  let productDetails: any = "";
  const getLocation: any = useLocation();
  if (getLocation && getLocation.state && getLocation.state.productDetails) {
    productDetails = getLocation.state.productDetails;
  }
  useEffect(() => {
    fetchMails();
    // fetchProductDetails();
  }, []);
  const fetchMails = async () => {
    setLoader(true);
    try {
      const mailData: any = await Http.get({
        url: `/api/v2/mailing/${ticketId}`,
        state: userInfo,
      });
      appLogger.info({
        infoObj: {
          method: "fetchMails",
          component: "mailing",
          fileName: "mailingAnalyticsDrawer.tsx",
          mailData: mailData,
        },
      });
      if (mailData && mailData.length) {
        updateSubject(mailData[0].subject);
        // const combinedArray = combineObjects(mailData);
        // console.log(mailData, "mailData");
        mailData.sort(compareMailDates);
        setMails(mailData);
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      props.snackbarShowMessage("Error in fetching new mails", "error");
      appLogger.error({
        infoObj: {
          method: "fetchMails",
          component: "mailing",
          fileName: "mailingAnalyticsDrawer.tsx",
          error: error,
        },
      });
    }
  };
  const fetchProductDetails = () => {
    setLoader(true);
    if (productDetails) {
      setLoader(true);
      Http.get({
        url: `/api/v2/products/${productDetails.productId}/${productDetails.productVersion}`,
        state: userInfo,
      })
        .then((response: any) => {
          setLoader(false);
          if (response && response.products && response.products.length > 0) {
            const details = response.products[0];
            if (details && Object.keys(details.emailConfig).length > 0) {
              if (
                pagetype == getpageTypeEmail(pagetype) &&
                Object.keys(details.emailConfig[getpageTypeForEmail(pagetype)])
                  .length > 0 &&
                Object.keys(
                  details.emailConfig[getpageTypeForEmail(pagetype)][
                    "emailSettings"
                  ]
                ).length > 0
              ) {
                const datass =
                  details.emailConfig[getpageTypeForEmail(pagetype)][
                    "emailSettings"
                  ];
                if (datass && datass.emailSalutation != "") {
                  setEmailSaluation(datass.emailSalutation);
                }
                if (datass && datass.emailSignature != "") {
                  setEmailSignature(datass.emailSignature);
                }
              }
            }
          }

          // setFeedbackAgentSettingsFetched(true);
        })
        .catch((error: any) => {
          appLogger.error({
            errObj: {
              method: "useEffect",
              component: "add-products",
              fileName: "index.tsx",
              err: error,
            },
          });
          props.snackbarShowMessage("products fetch error", "error", 3000);
        });
    } else {
      // setProductParams({ products: [newProd] });
    }
  };
  // Function to combine objects based on messageId
  const combineObjects = (mails: any) => {
    const combined: any = {};
    mails.forEach((obj: any) => {
      const { messageId } = obj;
      if (!combined[messageId]) {
        combined[messageId] = { ...obj };
      } else {
        Object.assign(combined[messageId], obj);
      }
    });
    return Object.values(combined);
  };

  const compareMailDates = (a: any, b: any) => {
    return a.createdOn > b.createdOn ? 1 : -1;
  };
  const toggleExpanded = () => {
    setExpanded(!expanded);
  };
  const handleSendReply = () => {
    setshowReplySection(!showReplySection);
  };
  const onDelete = () => {
    setshowReplySection(!showReplySection);
  };
  const forwardIcon = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.28009 0.969592C4.4207 1.11024 4.49968 1.30097 4.49968 1.49984C4.49968 1.69871 4.4207 1.88944 4.28009 2.03009L2.56034 3.74984H6.74985C8.14223 3.74984 9.4776 4.30297 10.4621 5.28753C11.4467 6.27207 11.9999 7.60744 11.9999 8.99982V10.4998C11.9999 10.6987 11.9208 10.8895 11.7802 11.0301C11.6396 11.1708 11.4488 11.2498 11.2499 11.2498C11.051 11.2498 10.8602 11.1708 10.7195 11.0301C10.5788 10.8895 10.4999 10.6987 10.4999 10.4998V8.99982C10.4999 8.00524 10.1048 7.05147 9.40148 6.3482C8.6982 5.64493 7.74443 5.24984 6.74985 5.24984H2.56034L4.28009 6.96957C4.35173 7.03879 4.40886 7.12152 4.44817 7.21302C4.48748 7.30452 4.50816 7.40299 4.50903 7.50252C4.50989 7.60212 4.49092 7.70089 4.45321 7.79307C4.4155 7.88524 4.3598 7.96895 4.28939 8.03937C4.21897 8.1098 4.13523 8.16552 4.04306 8.20324C3.95088 8.24089 3.85212 8.25987 3.75254 8.25904C3.65296 8.25814 3.55454 8.23744 3.46304 8.19814C3.37154 8.15884 3.28877 8.10169 3.21959 8.03007L0.219592 5.03009C0.07899 4.88944 0 4.69871 0 4.49984C0 4.30097 0.07899 4.11024 0.219592 3.96959L3.21959 0.969592C3.36023 0.82899 3.55097 0.75 3.74984 0.75C3.94871 0.75 4.13945 0.82899 4.28009 0.969592Z"
          fill="#0157ff"
        />
      </svg>
    );
  };
  const handleOnChange = (value: any) => {
    // setEditorData(value);
  };
  const updateEmailList = () => {
    fetchMails();
    setshowReplySection(!showReplySection);
  };
  const getInitials = (name: string) => {
    return name.slice(0, 1);
  };

  const setImageUrl = (mail: any) => {
    if (!mail.body.includes("<img")) return mail.body;

    const htmlString = mail.body; // Your HTML string
    const parser = new DOMParser();
    const parsedHtml = parser.parseFromString(htmlString, "text/html");

    // Modify the src attribute of the img tag
    const imgNodes = parsedHtml.querySelectorAll("img");
    for (let i = 0; i < imgNodes.length; i++) {
      const img = imgNodes[i];
      if (!img) return;

      const alt = img.alt;
      const attachmentURL = mail.attachmentInfo.find(
        (a: string) => decodeURIComponent(a.split("/")[7]) == alt
      );

      if (attachmentURL) {
        img.src = attachmentURL;
      }
    }
    const modifiedHtml = new XMLSerializer().serializeToString(parsedHtml);
    return modifiedHtml;
  };

  const redirectTicketReplyPage = (
    data: any,
    type: any,
    fbtype: any,
    feedbackdatas: any
  ) => {
    const pagetype =
      fbtype == "FEEDBACK"
        ? "feedback"
        : fbtype == "BUG_REPORT"
        ? "tickets"
        : "feature";
    navigate(`/${pagetype}/tickets-${type}/${data.id}`, {
      state: {
        productDetails: productDetails,
        tabType: new Date().getTime(),
      },
    });
  };

  const handlePreviewClose = () => {
    setPreview({ open: false, url: "", fileType: "", fileName: "" });
  };

  return (
    <Box className={loader ? "loader" : ""}>
      <List sx={{ p: 0 }}>
        {mails.map((mail: any, index: any) => (
          <React.Fragment key={mail.id}>
            {index < 2 || expanded ? (
              <>
                <ListItem className="emailListReply">
                  <ListItemAvatar>
                    <Avatar className="emailsenderavatar">
                      {getInitials(mail.createdBy)}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Typography className="emailSenderName">
                        <NameAndEmail text={mail.createdBy} />
                      </Typography>
                    }
                    // secondary={
                    //   <>
                    //     <Typography sx={{ fontSize: "12px" }}>
                    //       {"<"}
                    //       {mail.createdBy}
                    //       {">"}
                    //     </Typography>
                    //   </>
                    // }
                  />
                  <Typography className="emailReplyTime" variant="body2">
                    <DateTime date={mail.createdOn} />
                  </Typography>
                </ListItem>
                <ListItemText
                  className="emailListItem"
                  sx={{ mt: 1 }}
                  secondary={
                    <Typography
                      className="emailListItemP"
                      sx={{
                        fontSize: "13px",
                        color: "#092146",
                        margin: "0px !important",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: _.unescape(setImageUrl(mail)),
                      }}
                    ></Typography>
                  }
                  style={{ marginLeft: "56px", marginBottom: "10px" }} // Adjust margin to align with the avatar
                />
                <EmailAttachments
                  mail={mail}
                  setPreview={setPreview}
                  setLoader={setLoader}
                />

                {index < mails.length - 1 && <Divider variant="middle" />}
              </>
            ) : null}
            {index === 1 && mails.length > 2 && mails.length - 3 != 0 && (
              <div
                style={{ textAlign: "left" }}
                className="countRemainingEmail"
              >
                <IconButton onClick={toggleExpanded} sx={{ pr: 0 }}>
                  {expanded ? (
                    <ExpandLessIcon />
                  ) : (
                    <>
                      <Avatar className="emailRemainingCountAvatar">
                        {mails.length - 3}
                      </Avatar>
                    </>
                  )}
                </IconButton>
              </div>
            )}
          </React.Fragment>
        ))}
      </List>
      {/* Render the last message outside of the map */}
      {mails.length > 2 && !expanded && (
        <>
          <Divider variant="middle" />
          <ListItem className="emailListReply">
            <ListItemAvatar>
              <Avatar className="emailsenderavatar">
                {/* {mails[mails.length - 1].sender.charAt(0)} */}
                {getInitials(mails[mails.length - 1].createdBy)}
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={
                <>
                  <Typography className="emailSenderName">
                    {/* {mails[mails.length - 1].sender} */}
                    {mails[mails.length - 1].createdBy}
                  </Typography>
                </>
              }
              // secondary={
              //   <>
              //     <Typography sx={{ fontSize: "12px" }}>
              //       {"<"}
              //       {mails[mails.length - 1].createdBy}
              //       {">"}
              //     </Typography>
              //   </>
              // }
            />
            <Typography variant="body2" className="emailReplyTime">
              <DateTime date={mails[mails.length - 1].createdOn} />
            </Typography>
          </ListItem>
          <ListItemText
            className={`emailListItem`}
            sx={{ mt: 0 }}
            secondary={
              <>
                <Typography
                  className={`emailListItemP`}
                  sx={{ fontSize: "13px", color: "#092146" }}
                  dangerouslySetInnerHTML={{
                    __html: _.unescape(setImageUrl(mails[mails.length - 1])),
                  }}
                ></Typography>
              </>
            }
            style={{ marginLeft: "56px", marginBottom: "10px" }} // Adjust margin to align with the avatar
          />
          {mails[mails.length - 1].attachmentInfo &&
            mails[mails.length - 1].attachmentInfo.length > 0 && (
              <List>
                {mails[mails.length - 1].attachmentInfo.map(
                  (attach: string) => {
                    if (
                      !mails[mails.length - 1].body.includes(
                        decodeURIComponent(attach.split("/")[7])
                      )
                    ) {
                      return (
                        <ListItem>
                          <MediaAttachments
                            pageType={pagetype}
                            detailRow={{
                              attachment: {
                                file: attach,
                              },
                            }}
                          />
                        </ListItem>
                      );
                    }
                  }
                )}
              </List>
            )}
        </>
      )}
      {mails && mails.length == 0 && !loader && feedbackDetails && (
        <Typography
          className="report-info"
          sx={{
            borderRadius: "10px",
            border: "1px solid #cccccca1",
            marginBottom: "23px",
            padding: "13px 0px 20px 20px",
            background: "#eaeaea3d",
          }}
        >
          {feedbackDetails?.feedbackComments ? (
            <>
              <Grid sx={{ alignItems: "flex-end", display: "flex" }}>
                <Comments
                  comments={
                    feedbackDetails.feedbackComments &&
                    Object.keys(feedbackDetails.feedbackComments).length > 0
                      ? feedbackDetails.feedbackComments
                      : undefined
                  }
                  category={feedbackDetails.feedbackCategory}
                  feedbackType={feedbackDetails.feedbackType}
                  feedbackDetails={feedbackDetails}
                />
              </Grid>
              {feedbackDetails.inputSource == "chat" ? (
                <Box className="read-more-link" style={{ marginTop: "10px" }}>
                  <Typography
                    onClick={() =>
                      redirectTicketReplyPage(
                        feedbackDetails,
                        "reply",
                        feedbackDetails.feedbackType,
                        feedbackDetails
                      )
                    }
                  >
                    View Details
                  </Typography>
                </Box>
              ) : null}
            </>
          ) : (
            ""
          )}
        </Typography>
      )}

      {!showReplySection && (
        // mails.length > 0 &&
        <Grid mt={3}>
          <Button variant="outlined" color="primary" onClick={handleSendReply}>
            {forwardIcon()}&nbsp;&nbsp;Reply to customer
          </Button>
        </Grid>
      )}
      {showReplySection && (
        <EmailReplyEditorAI
          lastEmailId={
            feedbackDetails.userId
            // mails[0].isAutoReply ? mails[0].toMail : mails[0].createdBy
          }
          lastEmailAvatar={getInitials(
            feedbackDetails.userId
            // mails[mails.length - 1].createdBy
          )}
          // lastEmailId={
          //   mails && mails.length > 0
          //     ? mails[0].isAutoReply
          //       ? mails[0].toMail
          //       : mails[0].createdBy
          //     : feedbackDetails.userId
          // }
          // lastEmailAvatar={getInitials(
          //   mails && mails.length > 0
          //     ? mails[mails.length - 1].createdBy
          //     : feedbackDetails.userId
          // )}
          onDelete={onDelete}
          ticketId={ticketId}
          updateEmailList={updateEmailList}
          feedbackDetails={feedbackDetails}
          updateStatus={updateStatus}
          EmailSaluation={EmailSaluation}
          EmailSignature={EmailSignature}
          emailsCount={mails.length}
          subjectVal={subjectVal}
        />
      )}
      {mails && mails.length == 0 && !loader ? (
        <Typography
          sx={{ display: "flex", justifyContent: "center" }}
          className="aisuggestionhelptext"
          style={{ color: "#07367e75", fontSize: "14px" }}
        >
          No Emails Found
        </Typography>
      ) : (
        <></>
      )}

      <Dialog open={preview.open} onClose={handlePreviewClose}>
        <>
          {preview.fileType === "IMAGE" && (
            <Box>
              <img src={preview.url} alt="attachment preview" />
            </Box>
          )}
          {preview.fileType === "VIDEO" && (
            <Box>
              <video controls>
                <source src={preview.url} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </Box>
          )}
        </>
      </Dialog>
    </Box>
  );
};

export default withSnackbar(EmailReply);
